export class Category {
  frontendDisplay: boolean;
  hidden: boolean;
  frontPageCategory: boolean;
  kioskOnly: boolean;
  frontPageProductsCount: number;
  id: number;
  name: string;
  title: string;
  description: string;
  pageTitle: string;
  pageDescription: string;
  categoryUrl: string;
  isInherited: boolean;
  backgroundImageUrl: string;
  backgroundImageDarken: boolean;

  subCategories: Category[];

  // Meny
  imageUrl: string;
}

export class TreeNode<T> {
  data: T;
  parent?: TreeNode<T>;
  children: TreeNode<T>[] = [];
  level: number;

  constructor(data: T, level?: number) {
    this.data = data;
    this.level = level;
  }

  addChild(child: TreeNode<T>) {
    child.parent = this;
    child.level = this.level + 1;
    this.children.push(child);
  }
}

export class Tree<T> {
  root: TreeNode<T>;

  constructor(root: T) {
    this.root = new TreeNode(root, 0);
  }

  find(callback: (node: T) => boolean, result: TreeNode<T>[], node?: TreeNode<T>): TreeNode<T>[] | undefined {
    if (!node) {
      return undefined;
    }

    if (callback(node.data)) {
      result.push(node);
      return result;
    }

    let found;
    for (const child of node.children) {
      found = this.find(callback, result, child);

      if (found) {
        return found;
      }
    }

    return undefined;
  }
}

export class Forest<T> {
  trees: Tree<T>[] = [];

  addTree(tree: Tree<T>) {
    this.trees.push(tree);
  }

  find(callback: (node: T) => boolean): TreeNode<T> | undefined {
    let results: TreeNode<T>[] = [];
    let nodes: TreeNode<T>[];
    for (const tree of this.trees) {
      nodes = tree.find(callback, [], tree.root);

      if (nodes) {
        results = results.concat(nodes);
      }
    }

    if (results.length === 1) {
      return results[0];
    }

    if (results.length > 1) {
      let shallowestNode = results[0];
      for (const node of results) {
        if (node.level < shallowestNode.level) {
          shallowestNode = node;
        }
      }

      return shallowestNode;
    }

    return undefined;
  }
}

export const isForest = (obj: any): obj is Forest<any> => {
  return (obj as Forest<any>)?.trees !== undefined;
};

export const isTreeNode = (obj: any): obj is TreeNode<any> => {
  return (obj as TreeNode<any>)?.data !== undefined;
};
